import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import { injectIntl, FormattedMessage } from 'react-intl'
import Loader from 'src/components/Loader/Loader'
import { Box, Text } from '@chakra-ui/react'
import { Layout, Container, Content, PageTitle } from 'src/components/Layout'
import ThankYou from 'src/modals/ThankYou/ThankYou'
import { Input } from 'src/components/Form'
import { Form, Field } from 'react-final-form'
import { isEmpty } from 'src/utils/helpers'
import Button from 'src/components/Button/Button'
import intlMessagesApp from 'src/modules/App/translations'
import intlMessages from '../translations'
import withToast from 'src/components/Toast'
import styles from './styles.module.less'

const EXCLUDED_BROKERS = ['birkett']

class ETransferInstructions extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isSent: false,
      secretPassword: props.eTransferSecret || '',
    }
  }

  componentDidMount() {
    const { history, selectedPaymentPolicies, isETransfer } = this.props

    if (!(selectedPaymentPolicies && selectedPaymentPolicies.length > 0) || isETransfer !== true) {
      // If policies are not selected, go back to that page
      history.push('/payments')
    }
  }

  componentDidUpdate(prevProps) {
    const { intl, sendETransferEmailResponse, toast } = this.props

    // If there is save response and it changed (it's empty object while submitting)
    if (
      !isEmpty(sendETransferEmailResponse) &&
      sendETransferEmailResponse !== prevProps.sendETransferEmailResponse
    ) {
      if (sendETransferEmailResponse.success) {
        this.setState({
          isSent: true,
        })
      } else {
        toast({
          title: intl.formatMessage(intlMessagesApp.appErrorTitle),
          description:
            sendETransferEmailResponse.message ||
            intl.formatMessage(intlMessagesApp.appErrorDescription),
          status: 'error',
        })
      }
    }
  }

  handleFinish = () => {
    const { history } = this.props

    if (history) {
      // Go back to home page
      history.push('/')
    }
  }

  handleSendEmail = values => {
    const { selectedPaymentPolicies, eTransferEmail, sendETransferEmail } = this.props
    if (selectedPaymentPolicies.length > 0 && eTransferEmail.length > 0) {
      sendETransferEmail({
        referenceEmail: eTransferEmail,
        policies: selectedPaymentPolicies,
        secretPassword: values.secretPassword,
      })
    }
  }

  handleFieldChange = (e, fieldState) => {
    this.setState({
      [fieldState]: e.target.value,
    })
  }

  validateFormFields = values => {
    const { intl } = this.props

    const errors = {}
    if (!this.isStep2Disabled()) {
      if (!values.secretPassword) {
        errors.secretPassword = intl.formatMessage(intlMessages.paymentFormErrorSecretPassword)
      }
    }
    return errors
  }

  isStep2Disabled() {
    return EXCLUDED_BROKERS.includes(this.props.subdomain)
  }

  render() {
    const { isSent, secretPassword } = this.state
    const { intl, eTransferEmail, isETransferEmailInProgress, features } = this.props

    const foundedFeature = features.find(f => f.id == 'payments')
    const title =
      foundedFeature && foundedFeature.title
        ? foundedFeature.title
        : intl.formatMessage(intlMessages.paymentHeadline)

    return (
      <Layout>
        <Content>
          <PageTitle title={'E-Transfer Instructions'} subtitle={title} />
          <Container padder className={styles.container}>
            {isETransferEmailInProgress ? (
              <Loader styleVariation='staticWithHeight' />
            ) : (
              <Box className={styles.instructionsHolder}>
                <Form
                  validate={this.validateFormFields}
                  onSubmit={this.handleSendEmail}
                  render={({ handleSubmit }) => (
                    <form onSubmit={handleSubmit}>
                      <Box p={'20px'} className={styles.stepCard} align={'center'}>
                        <Text
                          mb={'20px'}
                          fontSize={'18px'}
                          className={styles.stepTitle}
                          variant='card'
                        >
                          {!this.isStep2Disabled() ? (
                            <FormattedMessage id='app.steps.step1' defaultMessage='Step 1' />
                          ) : null}
                        </Text>
                        <div className={styles.emailInstructionsHolder}>
                          <Text fontSize={'18px'} variant='card' opacity={0.6}>
                            <FormattedMessage
                              id='app.payment.eTransfer.sentTo'
                              defaultMessage='Please send e-transfer payment to'
                            />
                          </Text>
                          <Text className={styles.emailInstructionsEmail}>
                            {eTransferEmail || '-'}
                          </Text>
                        </div>
                      </Box>
                      {!this.isStep2Disabled() ? (
                        <Box mt={'15px'} p={'20px'} className={styles.stepCard} align={'center'}>
                          <Text
                            mb={'20px'}
                            fontSize={'18px'}
                            className={styles.stepTitle}
                            variant='card'
                          >
                            <FormattedMessage id='app.steps.step2' defaultMessage='Step 2' />
                          </Text>
                          <div className={styles.secretPasswordHolder}>
                            <Text fontSize={'18px'} variant='card' opacity={0.6}>
                              <FormattedMessage
                                id='app.payment.eTransfer.secretPasswordDescription'
                                defaultMessage='Please enter your "secret password"'
                              />
                            </Text>
                            <div className={styles.secretPassword}>
                              <Field
                                name='secretPassword'
                                initialValue={secretPassword}
                                render={({ input, meta }) => (
                                  <Box mt={'25px'}>
                                    <Input
                                      placeholder={intl.formatMessage(
                                        intlMessages.paymentFormLabelSecretPassword,
                                      )}
                                      error={meta}
                                      name='secretPassword'
                                      {...input}
                                    />
                                  </Box>
                                )}
                              />
                            </div>
                          </div>
                        </Box>
                      ) : null}

                      <Button mt={'30px'} type='submit' isFullWidth>
                        <FormattedMessage id='app.sendEmail' defaultMessage='Send email' />
                      </Button>
                    </form>
                  )}
                />
                <ThankYou
                  visible={isSent}
                  onClose={this.handleFinish}
                  renderContent={() => (
                    <div className={styles.thankYouText}>
                      <FormattedMessage
                        id='app.payment.eTransfer.thankYouText'
                        defaultMessage='Your email has been sent.'
                      />
                    </div>
                  )}
                />
              </Box>
            )}
          </Container>
        </Content>
      </Layout>
    )
  }
}

export default withRouter(injectIntl(withToast(ETransferInstructions)))
